import React, { ReactNode } from 'react';
import {
  ToolbarCollectionEmptyStateBase,
  ToolbarCollectionEmptyStateBaseProps,
} from './ToolbarCollectionEmptyStateBase';
import { observer } from 'mobx-react-lite';
import { AddItemEmptyState } from '../Illustration/AddItemEmptyState';
import { useToolbarCollectionEmptyStateImage } from '../../hooks/useToolbarCollectionEmptyStateImage';
import { useMultiCollectionSupportContext } from '../MultiCollectionSupportProvider';

export interface ToolbarCollectionEmptyStateProps
  extends Partial<ToolbarCollectionEmptyStateBaseProps> {
  children?: ReactNode;
}

function _ToolbarCollectionEmptyState(
  props: Omit<ToolbarCollectionEmptyStateProps, 'image'>,
) {
  const state = useMultiCollectionSupportContext();
  const image = useToolbarCollectionEmptyStateImage({
    state,
    image: <AddItemEmptyState data-hook="empty-state-new-item-illustration" />,
  });

  return (
    <ToolbarCollectionEmptyStateBase
      dataHook="collection-empty-state"
      image={image}
      {...props}
    />
  );
}

export const ToolbarCollectionEmptyState = observer(
  _ToolbarCollectionEmptyState,
);
